var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._b({},'span',_vm.attrs,false),[_vm._v(" "+_vm._s(_vm.sTitulo)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }